/**
 * Leaflet Fix
 * Fixar kompatibilitetsproblem mellan react-leaflet och leaflet i Vite
 */

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Exportera Control explicit för react-leaflet
export const Control = L.Control;

// Fix för default marker icons
const iconUrl = 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png';
const iconShadowUrl = 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
  iconUrl: iconUrl,
  shadowUrl: iconShadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

// Exportera L som default
export default L;

